











import { Component, Vue } from 'vue-property-decorator'
import { $myPeer } from '@/index'
import { PeerModule } from '@/store'

@Component
export default class Name extends Vue {
  $peer: $myPeer;
  userName = '';

  setName (e) {
    e.preventDefault()
    if (!this.userName) {
      return false
    }
    PeerModule.sendMessage({ type: 'SET_NAME', payload: this.userName })
    this.$router.replace('words')
  }
}
